<template>
    <Approvals></Approvals>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const Approvals = defineAsyncComponent(() =>
    import("../../components/CNC/Approvals.vue")
);

export default {
    name: "CNC_Approvals", //The name you are in should not equal the name of the component you are importing.
    components: { Approvals, AuthLayout },
};
</script>
